import Skeleton from '@mui/material/Skeleton';
import { BaseSkeletonProps } from '../../../../types';
import { useId } from '../../../../lib/hooks/useId';
import styles from './RelatedVideos.module.scss';

export const RelatedVideosBrandSkeleton = ({ isLoading, children }: BaseSkeletonProps) => {
  if (isLoading) {
    return <Skeleton className={styles.brandSkeleton} />;
  }

  return children;
};

type RelatedVideosSkeletonProps = BaseSkeletonProps;

export const RelatedVideosSkeleton = ({ isLoading, children }: RelatedVideosSkeletonProps) => {
  const id = useId();

  if (isLoading) {
    return (
      <>
        {Array.from({ length: 6 }, (_, index) => `${id}-${index + 1}`).map(key => (
          <li key={key}>
            <div className={styles.skeleton}>
              <Skeleton className={styles.skeletonImage} />
              <Skeleton className={styles.skeletonLabel} />
              <Skeleton className={styles.skeletonTitle} />
              <Skeleton className={styles.skeletonChaptersList} />
            </div>
          </li>
        ))}
      </>
    );
  }

  return children;
};
